import Chip from '@mui/material/Chip';
import { observer } from 'mobx-react-lite';
import { Title } from '../../../../../components/display';
import VersionFile from '../store/VersionFile';
import classes from './PreviousFiles.module.scss';

export default observer(function PreviousFiles({
  files,
}: {
  files: VersionFile[];
}) {
  if (files.length === 0) {
    return null;
  }

  return (
    <>
      <div className={classes.previousFiles}>
        <Title variant="h3">Files from previous versions</Title>

        <div className={classes.previousFilesList}>
          {files.map((file) => (
            <Chip
              key={file.id}
              label={file.name}
              size="small"
              variant="outlined"
            />
          ))}
        </div>
      </div>

      <Title variant="h3">New files</Title>
    </>
  );
});
